import { Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserComposerService } from '../../core/services/user-composer.service';
import { isNullOrEmpty } from '../../core/utils/common-functions';

@Pipe({
  name: 'userComposer',
})
export class UserComposerPipe implements PipeTransform {
  constructor(private userCompserService: UserComposerService) {}

  transform(value: any, ...args: any[]): any {
    console.log('UserComposerPipe', value);
    const item = args.length > 0 ? args[0] : undefined;
    const userNameProp =
      args.length > 1 ? `${args[1]}ComposerName` : 'userNoComposerName';
    if (isNullOrEmpty(value)) {
      return of(null);
    }
    if (isNullOrEmpty(item)) {
      const displayUserInfoText$ = this.userCompserService
        .getUserInfo(value)
        .pipe(
          map((userInfo) =>
            this.displayUserInfoText(
              userInfo?.userNo ?? value,
              userInfo?.userName
            )
          )
        );
      return displayUserInfoText$;
    }

    const displayUserInfoText = this.displayUserInfoText(
      value,
      item[userNameProp]
    );
    return of(displayUserInfoText);
  }

  private displayUserInfoText(userNo?: string, userName?: string): string {
    const userNoStr = userNo ?? '';
    const userNameStr = userName ?? '';
    const seperator =
      !isNullOrEmpty(userNo) && !isNullOrEmpty(userName) ? ' ' : '';
    const displayText = `${userNoStr}${seperator}${userNameStr}`;
    return displayText;
  }
}
